var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFacebook(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 37,
    viewBox: "0 0 37 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.5 18.4353C0.5 28.4885 8.64972 36.6382 18.7029 36.6382C28.7561 36.6382 36.9058 28.4885 36.9058 18.4353C36.9058 8.38214 28.7561 0.232422 18.7029 0.232422C8.64972 0.232422 0.5 8.38214 0.5 18.4353Z",
    fill: "#212529"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27.8043 18.4352C27.8043 13.4294 23.7087 9.33374 18.7029 9.33374C13.6971 9.33374 9.60145 13.4294 9.60145 18.4352C9.60145 22.9859 12.9007 26.7403 17.2239 27.4229V21.0519H14.9485V18.4352H17.2239V16.3874C17.2239 14.112 18.5891 12.8606 20.637 12.8606C21.6609 12.8606 22.6848 13.0881 22.6848 13.0881V15.3635H21.5471C20.4094 15.3635 20.0681 16.0461 20.0681 16.7287V18.4352H22.571L22.1159 21.0519H19.9543V27.5366C24.5051 26.854 27.8043 22.9859 27.8043 18.4352Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.dc99a9e42de624b6724e12b42d059f0a.svg";
export { ForwardRef as ReactComponent };